import { withWindow } from './withWindow';
import type { EcardLookupPayload } from '../types/EcardLookupPayload';

/**
 * Generates a shareable link URL from an EcardLookupPayload
 * @param lookupPayload - The payload containing ecard lookup information
 * @returns The generated shareable link URL
 */
export const generateShareableLinkUrl = (lookupPayload: EcardLookupPayload): string => {
  const lookupId = Buffer.from(JSON.stringify(lookupPayload)).toString('base64');
  let generatedLink = '';
  withWindow(global => {
    generatedLink = `${global.location.origin}/ecard?lookup=${lookupId}`;
  });
  return generatedLink;
};
